import React from 'react';

import * as R from './constants/routes.constants';
import { ALERT_DEFINITIONS, SETTINGS_CHICKEN_GRILLED_MATERIALS } from './constants/routes.constants';

const LoginPage = React.lazy(() => import('./containers/SignIn/Login'));
const LoginExpiredPage = React.lazy(() => import('./containers/SignIn/ExpiredToken'));
const PasswordExpiredPage = React.lazy(() => import('./containers/SignIn/ExpiredChangePassword'));
const ResetPage = React.lazy(() => import('./containers/SignIn/Reset'));
const BlockedUserPage = React.lazy(() => import('./containers/SignIn/BlockedAccount'));
const EventsPage = React.lazy(() => import('./containers/EventsNav/Events'));
const AnalyticEventsPage = React.lazy(() => import('./containers/EventsNav/Analytics'));
const ChickenEventsPage = React.lazy(() => import('./containers/EventsNav/ChickenEvents'));
const RestaurantsPage = React.lazy(() => import('./containers/Restaurants/Restaurants'));
const AuditLogPage = React.lazy(() => import('./containers/Administration/AuditLog/AuditLog'));
const DevicesTabletsPage = React.lazy(() => import('./containers/Devices/Tablets'));
const DevicesPCPage = React.lazy(() => import('./containers/Devices/Devices'));
const TabletLogsPage = React.lazy(() => import('./containers/Devices/Logs/Logs'));
const TabletLogPage = React.lazy(() => import('./containers/Devices/Logs/Log'));
const TabletSessionsPage = React.lazy(() => import('./containers/Devices/TabletSessions'));
const TabletSettingsPage = React.lazy(() => import('./containers/Devices/TabletSettings'));
const SettingsChickenMaterialsPage = React.lazy(() =>
  import('./containers/Settings/Materials/ChickenMaterials')
);
const SettingsGrilledMaterialsPage = React.lazy(() =>
  import('./containers/Settings/GrilledMaterials/GrilledMaterials')
);
const SettingsChickenContainersPage = React.lazy(() =>
  import('./containers/Settings/Containers/ChickenContainers')
);
const SettingsMercoTraysPage = React.lazy(() => import('./containers/Settings/MercoTrays/MercoTrays'));
const SettingsChickenPackagesPage = React.lazy(() =>
  import('./containers/Settings/Packages/ChickenPackages')
);
const SettingsPotatoMaterialsPage = React.lazy(() =>
  import('./containers/Settings/Materials/PotatoMaterials')
);
const SettingsPotatoPackagesPage = React.lazy(() => import('./containers/Settings/Packages/PotatoPackages'));

const RestaurantPCPage = React.lazy(() => import('./containers/Devices/RestaurantPC'));
const RestaurantTabletsPage = React.lazy(() => import('./containers/Devices/RestaurantTablets'));
const SupportHistoryPage = React.lazy(() => import('./containers/SupportHistory/SupportHistory'));
const KitchenPlayerPage = React.lazy(() => import('./containers/KitchenPlayer/PlayerTab'));
const KitchenPlayerClipsPage = React.lazy(() => import('./containers/KitchenPlayer/Clips/Clips'));
const PlugPlayPage = React.lazy(() => import('./containers/PlugPlay/PlugPlay'));
const ArucoValidationPage = React.lazy(() => import('./containers/PlugPlay/ArucoValidation'));
const ChutesConfigPage = React.lazy(() => import('./containers/PlugPlay/ChutesConfig'));
const ChutesConfigSetupPage = React.lazy(() =>
  import('./containers/PlugPlay/ChutesConfig/ChutesConfigSetup')
);
const ChickenDashboardPage = React.lazy(() => import('./containers/Dashboard/ChickenDashboard'));
const ChickenChartsDashboardPage = React.lazy(() => import('./containers/Dashboard/ChickenChartsDashboard'));
// const PotatoDashboardPage = React.lazy(() => import('./containers/Dashboard/PotatoDashboard'));
const DPRemainingPage = React.lazy(() => import('./containers/Unusual/DPRemainingPotato'));
const IdenticalMarkerPage = React.lazy(() => import('./containers/Unusual/IdenticalMarkers'));
const UnusualPage = React.lazy(() => import('./containers/Unusual/UnusualEventInformation'));
const WrongMarkerPage = React.lazy(() => import('./containers/Unusual/WrongMarkerDetected'));
const EmptyPanPage = React.lazy(() => import('./containers/Unusual/EmptyPanDetected'));
const UnusualRecordingsPage = React.lazy(() => import('./containers/Unusual/UnusualEventRecordings'));

const TimersCyclePage = React.lazy(() => import('./containers/TimersCycle/TimersCycleHistory'));
const MercoTimerCyclePage = React.lazy(() => import('./containers/TimersCycle/MercoHotHoldingHistory'));
const FryChutesPage = React.lazy(() => import('./containers/TimersCycle/FryChutesInformation'));
const DumpPanPage = React.lazy(() => import('./containers/TimersCycle/DumpPanInformation'));
const PRQPage = React.lazy(() => import('./containers/TimersCycle/PRQ'));
const BreadingPage = React.lazy(() => import('./containers/TimersCycle/BreadingInformation'));
const ConveyorPage = React.lazy(() => import('./containers/TimersCycle/ConveyorInformation'));
const FryerPage = React.lazy(() => import('./containers/TimersCycle/FryerInformation'));
const CateringTimersPage = React.lazy(() => import('./containers/TimersCycle/CateringTimers'));
const EntreeChutesTimersPage = React.lazy(() => import('./containers/TimersCycle/EntreeChutesInformation'));
const PRSPage = React.lazy(() => import('./containers/TimersCycle/PRS'));
const AnalyticTimerCyclePage = React.lazy(() => import('./containers/TimersCycle/Analytics'));
const ChickenPerformancePage = React.lazy(() => import('./containers/Performance/ChickenPerformance'));
const SetPassword = React.lazy(() => import('./containers/SignIn/SetPassword'));
const ActiveSessionsPage = React.lazy(() => import('./containers/UserProfile/ActiveSessions/ActiveSessions'));
const AuthentificationLogPage = React.lazy(() =>
  import('./containers/UserProfile/AuthentificationLog/AuthentificationLog')
);
const UserSecurityPage = React.lazy(() => import('./containers/UserProfile/Security/Security'));
const MultiFactorAuthentication = React.lazy(() => import('./containers/SignIn/MultiFactorAuth'));
const MonitoringGraphicsPage = React.lazy(() => import('./containers/Monitoring/Graphics'));
const MonitoringPCSChartsPage = React.lazy(() => import('./containers/Monitoring/PCSCharts'));
const MonitoringAlertsPage = React.lazy(() => import('./containers/Monitoring/Alerts'));
const UsersManagementPage = React.lazy(() =>
  import('./containers/Administration/UsersManagement/UsersManagement')
);
const UserSessionsPage = React.lazy(() => import('./containers/Administration/UsersManagement/UserSessions'));
const PoliciesPage = React.lazy(() => import('./containers/Administration/Permissions/Policies/Policies'));
const RolesPage = React.lazy(() => import('./containers/Administration/Permissions/Roles/Roles'));
const CamerasViewPage = React.lazy(() => import('./containers/Cameras/CamerasView'));
const CamerasSettingsPage = React.lazy(() => import('./containers/Cameras/CamerasSettings'));
const CamerasRecordingsPage = React.lazy(() => import('./containers/Cameras/CamerasRecordings'));
const CamerasClipsPage = React.lazy(() => import('./containers/Cameras/components/Clips/ClipsPage'));
const ReportsPage = React.lazy(() => import('./containers/Reports/Reports'));
const ServerManagementPage = React.lazy(() => import('./containers/Monitoring/ServerManagement'));
const StockOutReportsPage = React.lazy(() => import('./containers/StockOutReports/StockOutReports'));
const MonitorPage = React.lazy(() => import('./containers/PCS/Monitor'));
const CateringInventoryPage = React.lazy(() => import('./containers/PCS/Catering'));
const FryerManagerPage = React.lazy(() => import('./containers/PCS/FryerManager'));
const AdjustmentPage = React.lazy(() => import('./containers/PCS/Adjustment'));
const AdjustmentVersionsPage = React.lazy(() => import('./containers/PCS/AdjustmentVersions/VersionHistory'));
const AdjustmentVersionPage = React.lazy(() => import('./containers/PCS/AdjustmentVersions/Version'));
const AdjustmentVersionComparisonPage = React.lazy(() =>
  import('./containers/PCS/AdjustmentVersions/VersionComparison')
);
const RecommendationsPage = React.lazy(() => import('./containers/PCS/Recommendations/Recommendations'));
const WastePage = React.lazy(() => import('./containers/Waste'));
const TrainingPage = React.lazy(() => import('./containers/Training'));
const TrainingDetailsPage = React.lazy(() => import('./containers/Training/Details'));
const AssistantActivityPage = React.lazy(() => import('./containers/Assistant/Activity'));
const AssistantHistoryPage = React.lazy(() => import('./containers/Assistant/History'));
const ResourcesPage = React.lazy(() => import('./containers/Resources/Resources'));
const AlertsPage = React.lazy(() => import('./containers/Alerts/Alerts'));
const AlertDefinitionsPage = React.lazy(() => import('./containers/Alerts/Definitions'));
const SupportGroupsPage = React.lazy(() => import('./containers/Alerts/Groups'));
const SupportUsersPage = React.lazy(() => import('./containers/Alerts/Users'));

const routes = [
  { path: R.LOGIN, component: LoginPage },
  { path: R.PASSWORD_RESET, component: ResetPage },
  { path: R.POTATO_EVENTS, component: EventsPage },
  { path: R.CHICKEN_DASHBOARD, component: ChickenDashboardPage },
  { path: R.CHICKEN_PERFORMANCE, component: ChickenPerformancePage },
  { path: R.HOT_HOLDING, component: TimersCyclePage },
  { path: R.MERCO_HOT_HOLDING, component: MercoTimerCyclePage },
  { path: R.ENTRY_CHUTES, component: ChickenDashboardPage },
  { path: R.BASKET_EVENTS, component: ChickenDashboardPage },
  { path: R.FRYER_EVENTS, component: FryerPage },
  { path: R.UNUSUAL_EVENT, component: UnusualPage },
  { path: R.DEVICES_PC, component: DevicesPCPage },
  { path: R.RESTAURANTS, component: RestaurantsPage },
  { path: R.RESTAURANTS_DEVICES_PC, component: RestaurantPCPage },
  { path: R.AUDIT_LOG, component: AuditLogPage },
  { path: R.SETTINGS_CHICKEN_MATERIALS, component: SettingsChickenMaterialsPage },
  { path: R.SETTINGS_CHICKEN_GRILLED_MATERIALS, component: SettingsGrilledMaterialsPage },
  { path: R.MONITORING_GRAPHICS, component: MonitoringGraphicsPage },
  { path: R.MONITORING_PCS_CHARTS, component: MonitoringPCSChartsPage },
  { path: R.USERS, component: UsersManagementPage },
  { path: R.KITCHEN_PLAYER, component: KitchenPlayerPage },
  { path: R.KITCHEN_PLAYER_CLIPS, component: KitchenPlayerClipsPage },
  { path: R.MULTI_FACTOR_AUTH, component: MultiFactorAuthentication },
  { path: R.MONITORING_ALERTS, component: MonitoringAlertsPage },
  { path: R.UNUSUAL_RECORDINGS, component: UnusualRecordingsPage },
  { path: R.SUPPORT_HISTORY, component: SupportHistoryPage },
  { path: R.SET_PASSWORD, component: SetPassword },
  { path: R.PLUG_TAB, component: PlugPlayPage },
  { path: R.CAMERAS_MANAGEMENT_RECORDINGS, component: CamerasRecordingsPage },
  { path: R.CAMERAS_MANAGEMENT_CLIPS, component: CamerasClipsPage },
  { path: R.CAMERAS_MANAGEMENT_VIEW, component: CamerasViewPage },
  { path: R.SERVER_MANAGEMENT, component: ServerManagementPage },
  //TODO add in the future
  // { path: R.FRAHA_DASHBOARD, component: PotatoDashboardPage },
  { path: R.RESTAURANTS_DEVICES_TABLETS, component: RestaurantTabletsPage },
  { path: R.DEVICES_TABLETS, component: DevicesTabletsPage },
  { path: R.CHICKEN_EVENTS, component: ChickenEventsPage },
  { path: R.ANALYTIC_EVENTS, component: AnalyticEventsPage },
  // TODO: temporary hidden pages (search for 'hidden pages')
  // { path: R.PRQ_EVENTS, component: PRQPage },
  // { path: R.FRY_CHUTES_EVENTS, component: FryChutesPage },
  // { path: R.DUMP_PAN_EVENTS, component: DumpPanPage },
  { path: R.TIMERS_ANALYTICS, component: AnalyticTimerCyclePage },
  { path: R.SETTINGS_POTATO_MATERIALS, component: SettingsPotatoMaterialsPage },
  { path: R.SETTINGS_CHICKEN_CONTAINERS, component: SettingsChickenContainersPage },
  { path: R.SETTINGS_CHICKEN_MERCO_TRAYS, component: SettingsMercoTraysPage },
  { path: R.UNUSUAL_DP_REMAINING, component: DPRemainingPage },
  { path: R.UNUSUAL_WRONG_MARKER, component: WrongMarkerPage },
  { path: R.UNUSUAL_IDENTICAL, component: IdenticalMarkerPage },
  { path: R.ARUCO_VALIDATION, component: ArucoValidationPage },
  { path: R.CHUTES_CONFIG, component: ChutesConfigPage },
  { path: R.CHUTES_CONFIG_SETUP, component: ChutesConfigSetupPage },
  { path: R.AUTHENTIFICATION_LOG, component: AuthentificationLogPage },
  { path: R.ACTIVE_SESSIONS, component: ActiveSessionsPage },
  { path: R.STOCK_OUT_REPORTS, component: StockOutReportsPage },
  { path: R.CAMERAS_MANAGEMENT_SETTINGS, component: CamerasSettingsPage },
  { path: R.LOGIN_EXPIRED, component: LoginExpiredPage },
  { path: R.CHANGE_EXPIRED_PASSWORD, component: PasswordExpiredPage },
  { path: R.REPORTS, component: ReportsPage },
  { path: R.USER_SECURITY, component: UserSecurityPage },
  { path: R.SETTINGS_POTATO_PACKAGES, component: SettingsPotatoPackagesPage },
  { path: R.BREADING_EVENTS, component: BreadingPage },
  { path: R.BLOCKED_USER, component: BlockedUserPage },
  { path: R.USER_SESSIONS, component: UserSessionsPage },
  { path: R.CONVEYOR_EVENTS, component: ConveyorPage },
  { path: R.TABLET_LOGS, component: TabletLogsPage },
  { path: R.TABLET_LOG, component: TabletLogPage },
  { path: R.TABLET_SESSIONS, component: TabletSessionsPage },
  { path: R.TABLET_SETTINGS, component: TabletSettingsPage },
  { path: R.PRODUCTION_QUEUE, component: MonitorPage },
  { path: R.CATERING_INVENTORY, component: CateringInventoryPage },
  { path: R.FRYER_MANAGER, component: FryerManagerPage },
  { path: R.ADJUSTMENT, component: AdjustmentPage },
  { path: R.ADJUSTMENT_VERSIONS, component: AdjustmentVersionsPage },
  { path: R.ADJUSTMENT_VERSION, component: AdjustmentVersionPage },
  { path: R.ADJUSTMENT_VERSION_COMPARISON, component: AdjustmentVersionComparisonPage },
  { path: R.RECOMMENDATIONS, component: RecommendationsPage },
  { path: R.CATERING_EVENTS, component: CateringTimersPage },
  { path: R.SETTINGS_CHICKEN_PACKAGES, component: SettingsChickenPackagesPage },
  { path: R.ENTREE_CHUTES_EVENTS, component: EntreeChutesTimersPage },
  { path: R.PRS_EVENTS, component: PRSPage },
  { path: R.UNUSUAL_EMPTY_PAN, component: EmptyPanPage },
  { path: R.POLICIES, component: PoliciesPage },
  { path: R.ROLES, component: RolesPage },
  { path: R.WASTE, component: WastePage },
  { path: R.CHICKEN_CHARTS_DASHBOARD, component: ChickenChartsDashboardPage },
  { path: R.TRAINING, component: TrainingPage, keepAlive: true },
  { path: R.TRAINING_DETAILS, component: TrainingDetailsPage },
  { path: R.ASSISTANT_ACTIVITY, component: AssistantActivityPage },
  { path: R.ASSISTANT_HISTORY, component: AssistantHistoryPage },
  { path: R.RESOURCES, component: ResourcesPage },
  { path: R.ALERTS, component: AlertsPage },
  { path: R.ALERT_DEFINITIONS, component: AlertDefinitionsPage },
  { path: R.SUPPORT_GROUPS, component: SupportGroupsPage },
  { path: R.SUPPORT_USERS, component: SupportUsersPage },
].map((item, id) => ({ id, ...item }));

export default routes;
